module.exports = __webpack_public_path__ + "static/licenced_carrier_icon-a4eb359d38e4539b345a982d19ff65cf.svg";